package com.anjuros.website.templates.template2.modules

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColor
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColorOpacity
import com.anjuros.website.templates.template1.modules.Template1Theme
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.rgb

enum class Template2Theme(
    val hex: String,
    val rgb: CSSColorValue
) {
    Primary(hex = "#1d365c", rgb = rgb(r = 29, g = 54, b = 92)),
    Accent(hex = "#89a8cb", rgb = rgb(r = 137, g = 168, b = 203)),

    OpacityPrimary(hex = "#1d365c", rgb = argb(a=0.2f,r = 29, g = 54, b = 92)),
    Secondary(hex = "#121D34", rgb = rgb(r = 18, g = 29, b = 52)),
    Gray(hex = "#CFCFCF", rgb = rgb(r = 207, g = 207, b = 207)),
    LightGray(hex = "#EDEDED", rgb = rgb(r = 237, g = 237, b = 237)),
    DarkGrey(hex = "#F9F9F9", rgb = rgb(r = 36, g = 37, b = 43)),
    Background(hex = "#F9F9F9", rgb = rgb(r = 252, g = 251, b = 250)),
}


@Composable
fun Template2Theme.getColor():CSSColorValue{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColor.rgb
}

@Composable
fun Template2Theme.getColorOpacity():CSSColorValue{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColorOpacity.rgb
}